import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

@Injectable()
export class ApplicationInsightsService {
  appInsights!: ApplicationInsights;
  private readonly _router = inject(Router);
  private readonly _location = inject(Location);

  initialization(instrumentationKey: string) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        enableAutoRouteTracking: false, // option to log all route changes
        disablePageUnloadEvents: ['unload'], // avoid deprecated 'unload' listener blocked by Permissions-Policy in Edge/Chrome
      },
    });
    this.appInsights.loadAppInsights();
    //this.appInsights.trackPageView();
    this._initRouteLog();
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights?.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({ name: name, uri: url });
  }

  logEvent(name: string, properties?: { [key: string]: unknown }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  private _initRouteLog() {
    this._router.events.subscribe((event: unknown) => {
      if (event instanceof NavigationEnd) {
        const routeTemplate = this._getRouteTemplate(this._router.routerState.snapshot.root);
        this.logPageView(routeTemplate, window.location.origin + this._location.prepareExternalUrl(event.urlAfterRedirects));
      }
    });
  }

  private _getRouteTemplate(route: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
      if (current.routeConfig?.path) {
        segments.push(current.routeConfig.path);
      }
      current = current.firstChild;
    }
    return window.location.origin + this._location.prepareExternalUrl(('/' + segments.join('/')).split('?')[0].split('#')[0]);
  }
}
